// Tabs for sections/gift-collection-tabs.liquid. The first panel ships with the
// page; other panels fetch their cards from ?view=gift-tab-cards the first time
// they open (or when the pointer/focus reaches their tab, to hide the wait).
if (!customElements.get('gift-collection-tabs')) {
  class GiftCollectionTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = this.tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
      this.max = parseInt(this.dataset.max, 10) || 8;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        tab.addEventListener('pointerenter', () => this.load(this.panels[index]), { once: true });
        tab.addEventListener('focus', () => this.load(this.panels[index]), { once: true });
      });
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = last;
      if (next === null) return;
      event.preventDefault();
      this.select(next);
      this.tabs[next].focus();
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active));
        if (active) tab.removeAttribute('tabindex');
        else tab.setAttribute('tabindex', '-1');
        this.panels[i].hidden = !active;
      });
      this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      this.load(this.panels[index]);
    }

    async load(panel) {
      if (!panel || panel.hasAttribute('data-loaded') || panel.loading) return;
      const src = panel.dataset.src;
      if (!src) return;
      panel.loading = true;
      const status = panel.querySelector('[data-gift-tabs-status]');
      try {
        const response = await fetch(src);
        if (!response.ok) throw new Error(String(response.status));
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = Array.from(doc.querySelectorAll('[data-gift-tab-items] > li')).slice(0, this.max);
        const list = panel.querySelector('[data-gift-tabs-list]');
        // Re-parse in this document: nodes adopted from a DOMParser document
        // keep their lazy images from ever starting to load in Chromium.
        list.insertAdjacentHTML('beforeend', items.map((item) => item.outerHTML).join(''));
        if (items.length) {
          panel.setAttribute('data-loaded', '');
        } else if (status) {
          status.textContent = 'Nothing here is in stock right now. Use the link below to see the full collection.';
        }
      } catch (error) {
        if (status) status.textContent = 'We couldn’t load these gifts. Use the link below to see the full collection.';
      } finally {
        panel.loading = false;
      }
    }
  }

  customElements.define('gift-collection-tabs', GiftCollectionTabs);
}
